<app-unauthorized-layout>
  <div class="registration-container">
    <div class="registration-image">
      <img src="assets/images/Primary-Logo.png" alt="Registration Logo" class="registration-logo-main" />
      <img src="assets/images/sub-logo.png" alt="Sub Logo" class="registration-logo-sub" />
    </div>
    <div class="registration-form-section">
    <h2 class="registration-title">{{ 'register.title' | translate }}</h2>
    <p class="registration-subtitle">{{ 'register.subtitle' | translate }}</p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <!-- Row 1: Full Name & Email -->
      <div class="form-row">
        <div class="form-group">
          <label for="fullName">{{ 'register.fullName' | translate }}<span class="required">*</span></label>
          <input
            type="text"
            id="fullName"
            class="form-control"
            formControlName="fullName"
            [class.error]="form.get('fullName')?.invalid && form.get('fullName')?.touched"
            placeholder="{{ 'register.fullName' | translate }}"
            required
            />
            @if (getFieldError('full-name')) {
              <small class="error-message">{{ getFieldError('full-name') }}</small>
            }
          </div>

          <div class="form-group">
            <label for="email">{{ 'register.email' | translate }}<span class="required">*</span></label>
            <input
              type="email"
              id="email"
              class="form-control"
              formControlName="email"
              [class.error]="form.get('email')?.invalid && form.get('email')?.touched"
              placeholder="{{ 'register.email' | translate }}"
              required
              />
              @if (getFieldError('email')) {
                <small class="error-message">{{ getFieldError('email') }}</small>
              }
            </div>
          </div>

          <!-- Row 2: Password & Confirm Password -->
          <div class="form-row">
            <div class="form-group">
              <label for="password">{{ 'login.password' | translate }}<span class="required">*</span></label>
              <div class="password-wrapper">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  class="form-control"
                  formControlName="password"
                  [class.error]="form.get('password')?.invalid && form.get('password')?.touched"
                  placeholder="{{ 'register.password' | translate }}"
                  (keyup)="form.get('password')?.markAsTouched()"
                  required
                  />
                  <button type="button" class="toggle-password" (click)="showPassword = !showPassword">
                    <img [src]="showPassword ? 'assets/icons/eye-slash.svg' : 'assets/icons/eye.svg'"
                      alt="toggle password visibility" width="20" height="20" />
                    </button>
                  </div>
                  @if (getFieldError('password')) {
                    <small class="error-message">{{ getFieldError('password') }}</small>
                  }

                  <!-- Password Strength Indicator -->
                  @if (form.get('password')?.touched && form.get('password')?.value) {
                    <div>
                      <small class="d-block mb-1 fw-semibold">{{ 'register.passwordStrength' | translate }}</small>
                      <div class="password-strength-checklist">
                        <div class="strength-item" [class.valid]="passwordStrength.hasNumber">
                          <i [ngClass]="passwordStrength.hasNumber ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                          <span>{{ 'register.containsNumber' | translate }}</span>
                        </div>
                        <div class="strength-item" [class.valid]="passwordStrength.hasLetter">
                          <i [ngClass]="passwordStrength.hasLetter ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                          <span>{{ 'register.containsLetter' | translate }}</span>
                        </div>
                        <div class="strength-item" [class.valid]="passwordStrength.hasSpecial">
                          <i [ngClass]="passwordStrength.hasSpecial ? 'bi bi-check-circle-fill' : 'bi bi-circle'"></i>
                          <span>{{ 'register.containsSpecial' | translate }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>

                <div class="form-group">
                  <label for="confirmPassword">{{ 'register.confirmPassword' | translate }}<span class="required">*</span></label>
                  <div class="password-wrapper">
                    <input
                      [type]="showConfirmPassword ? 'text' : 'password'"
                      id="confirmPassword"
                      class="form-control"
                      formControlName="confirmPassword"
                      [class.error]="form.get('confirmPassword')?.invalid && form.get('confirmPassword')?.touched"
                      placeholder="{{ 'register.confirmPassword' | translate }}"
                      required
                      />
                      <button type="button" class="toggle-password" (click)="showConfirmPassword = !showConfirmPassword">
                        <img [src]="showConfirmPassword ? 'assets/icons/eye-slash.svg' : 'assets/icons/eye.svg'"
                          alt="toggle password visibility" width="20" height="20" />
                        </button>
                      </div>
                      @if (getFieldError('confirm-password')) {
                        <small class="error-message">{{ getFieldError('confirm-password') }}</small>
                      }
                    </div>
                  </div>

                  <!-- Row 3: Mobile Number & Position -->
                  <div class="form-row">
                    <div class="form-group">
                      <label for="phoneNumber">{{ 'register.mobileNumber' | translate }}<span class="required">*</span></label>
                      <input
                        type="tel"
                        id="phoneNumber"
                        class="form-control"
                        formControlName="phoneNumber"
                        [class.error]="form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched"
                        placeholder="1234567890"
                        required
                        />
                        @if (getFieldError('phone-number')) {
                          <small class="error-message">{{ getFieldError('phone-number') }}</small>
                        }
                      </div>

                      <div class="form-group">
                        <label for="position">{{ 'register.position' | translate }}<span class="required">*</span></label>
                        <input
                          type="text"
                          id="position"
                          class="form-control"
                          formControlName="position"
                          [class.error]="form.get('position')?.invalid && form.get('position')?.touched"
                          placeholder="{{ 'register.position' | translate }}"
                          required
                          />
                          @if (getFieldError('position')) {
                            <small class="error-message">{{ getFieldError('position') }}</small>
                          }
                        </div>
                      </div>

                      <!-- Row 4: Organization & User Type -->
                      <div class="form-row">
                        <div class="form-group">
                          <label for="organization">{{ 'register.organization' | translate }}<span class="required">*</span></label>
                          <input
                            type="text"
                            id="organization"
                            class="form-control"
                            formControlName="organization"
                            [class.error]="form.get('organization')?.invalid && form.get('organization')?.touched"
                            placeholder="{{ 'register.organization' | translate }}"
                            required
                            />
                            @if (getFieldError('organization')) {
                              <small class="error-message">{{ getFieldError('organization') }}</small>
                            }
                          </div>

                          <div class="form-group">
                            <label for="userTypeId">{{ 'register.userType' | translate }}<span class="required">*</span></label>
                            <div class="select-wrapper">
                              <select
                                id="userTypeId"
                                class="form-select"
                                formControlName="userTypeId"
                                [class.error]="form.get('userTypeId')?.invalid && form.get('userTypeId')?.touched"
                                required
                                >
                                <option value="" selected>Select a user type</option>
                                @for (userType of userTypes; track userType) {
                                  <option [value]="userType.id">
                                    {{ userType.typeName }}
                                  </option>
                                }
                              </select>
                              <img src="assets/icons/arrow-down.svg" alt="dropdown arrow" class="select-arrow" />
                            </div>
                            @if (getFieldError('user-type-id')) {
                              <small class="error-message">{{ getFieldError('user-type-id') }}</small>
                            }
                          </div>
                        </div>

                        <!-- Row 5: ID Attachment (Full Width) -->
                        <div class="form-group">
                          <label for="idAttachment">{{ 'register.idAttachment' | translate }}<span class="required">*</span></label>
                          <div class="file-upload-wrapper">
                            <input
                              type="file"
                              id="idAttachment"
                              class="form-control file-input-hidden"
                              accept=".pdf,.jpg,.jpeg,.png"
                              formControlName="idAttachment"
                              [class.error]="fieldErrors['id-attachment']?.length"
                              (change)="onFileChange($event)"
                              required
                              />
                              <div class="file-info">
                                <span class="upload-text">{{ selectedFileName || 'Accepted formats: PDF, JPG, PNG (Max 5MB)' }}</span>
                              </div>
                              <button type="button" class="upload-btn" (click)="triggerFileUpload()">
                                <img src="assets/icons/upload.svg" class="upload-svg" alt="upload" width="16" height="16" />
                                <span>Upload</span>
                              </button>
                            </div>
                            @if (fieldErrors['id-attachment']?.length) {
                              <small class="error-message">{{ fieldErrors['id-attachment'][0] }}</small>
                            }
                          </div>

                          <!-- Row 6: Justification (Full Width) -->
                          <div class="form-group">
                            <label for="justification">{{ 'register.justification' | translate }}<span class="required">*</span></label>
                            <textarea
                              id="justification"
                              class="form-control"
                              formControlName="justification"
                              [class.error]="form.get('justification')?.invalid && form.get('justification')?.touched"
                              placeholder="{{ 'register.justificationPlaceholder' | translate }}"
                              rows="2"
                              required
                            ></textarea>
                            @if (getFieldError('justification')) {
                              <small class="error-message">{{ getFieldError('justification') }}</small>
                            }
                          </div>

                          <!-- Error Message -->
                          @if (errorMessage) {
                            <div class="alert alert-danger" role="alert">
                              {{ errorMessage }}
                            </div>
                          }

                          <!-- Success Message -->
                          @if (successMessage) {
                            <div class="alert alert-success" role="alert">
                              {{ successMessage }}
                            </div>
                          }

                          <!-- Submit Button -->
                          <button
                            type="submit"
                            class="register-btn"
                            [disabled]="isLoading || form.invalid || isSubmitted"
                            >
                            @if (!isLoading) {
                              <span>{{ 'register.submitButton' | translate }}</span>
                            }
                            @if (isLoading) {
                              <span>{{ 'common.loading' | translate }}</span>
                            }
                          </button>

                          <!-- Login Link -->
                          <div class="text-center mt-4">
                            <p class="mb-0">
                              {{ 'register.alreadyHaveAccount' | translate }}
                              <a routerLink="/login" class="fw-semibold">{{ 'register.loginHere' | translate }}</a>
                            </p>
                          </div>

                        </form>
                      </div>
                    </div>
</app-unauthorized-layout>